import { nanoid } from 'nanoid';
import { CARD_TYPES } from '../../../constants';

import {
  extractIngredientsFromList,
  getProductCarouselTranslations,
  getTitle,
  mergeCarouselProperties,
} from '../helpers';
import {
  getActions,
  getProductContainerPlacements,
} from '../helpers/analytics';
import { getCommonProps } from '../helpers/commonHelpers';

export const prepareCardData = cardData => {
  const conceptIds = cardData?.properties?.conceptIds;
  const viewAllButton = {
    actionText: 'shop all',
    actionType: 'link',
    destination: { conceptIds, type: 'GRIDWALL' },
    id: nanoid(),
  };
  const sectionHeadline = getTitle({
    ...cardData,
    properties: { ...cardData?.properties, actions: [viewAllButton] },
  });
  const maxResults =
    cardData?.properties?.custom?.maxResults < 8
      ? cardData?.properties?.custom?.maxResults
      : 10;

  return {
    ...getCommonProps(cardData),
    collectionId: conceptIds,
    dataQa: CARD_TYPES.PRODUCT_WALL,
    maxResults,
    sectionHeadline,
    slides: [],
  };
};

export const prepareTranslations = (translationsStrings = {}) => ({
  ...getProductCarouselTranslations(translationsStrings),
  viewAllLabel: translationsStrings.view_all,
});

export const mergeProperties = data => {
  let paramData = data;
  if (paramData?.cardData?.sectionHeadline?.actions?.[0]?.actionText) {
    paramData = {
      ...paramData,
      cardData: {
        ...paramData.cardData,
        sectionHeadline: {
          ...paramData.cardData.sectionHeadline,
          actions: [
            {
              ...paramData.cardData.sectionHeadline.actions[0],
              actionText: paramData.translations.viewAllLabel,
            },
            ...paramData.cardData.sectionHeadline.actions.slice(1),
          ],
        },
      },
    };
  }
  return mergeCarouselProperties(paramData);
};

export const getUrlIngredients = card => [
  ...extractIngredientsFromList(card?.sectionHeadline.actions),
  ...extractIngredientsFromList(card?.slides),
];

export { getProductContainerPlacements as getAnalyticsPlacements };

export const getAnalyticsActions = card =>
  getActions(card.sectionHeadline.actions);

export { getBuyingToolsIngredients } from './common';
